import React, { useState,useContext } from 'react';
import { Plus, Eye, Edit2, Trash2, X, ChevronLeft, ChevronRight, ArrowLeft, Upload } from 'lucide-react';
import '../../../../assets/css/admin/dashboardCSS/BlogManagement.css';
import { Row, Col, Card, Form, InputGroup } from 'react-bootstrap';
import { FaSearch, FaFilter } from 'react-icons/fa';
import Adminlayout from '../../../../layouts/admin/Adminlayout';
import TitleBar from '../../../../subscreens/admin/TitleBar';
import AppContext from '../../../../context/AppContext';
const BlogManagement = () => {
  const [view, setView] = useState('list'); // 'list', 'form'
  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [blogs, setBlogs] = useState([
    {
      id: 1,
      title: 'Ayesha Education Journey',
      shortDesc: 'A story of determination and success',
      fullStory: 'Ayesha, a young girl from a rural area, overcame numerous obstacles to pursue her education. With the support of generous donors, she is now studying at university and dreams of becoming a teacher to help other children in her community.',
      category: 'Student',
      status: 'Active',
      date: '12 Jan 2026',
      image: 'https://via.placeholder.com/150'
    },
    {
      id: 2,
      title: 'Donor Impact Story',
      shortDesc: 'How donations change lives',
      fullStory: 'Our donors have made an incredible impact on countless lives. This story showcases how a single donation can create a ripple effect of positive change in communities.',
      category: 'Donor',
      status: 'InActive',
      date: '08 Jan 2026',
      image: 'https://via.placeholder.com/150'
    },
    {
      id: 3,
      title: 'NGO Awareness Campaign',
      shortDesc: 'Spreading awareness about education',
      fullStory: 'Our NGO partners work tirelessly to spread awareness about the importance of education. This campaign reached over 10,000 families in remote areas.',
      category: 'NGO',
      status: 'Active',
      date: '05 Jan 2026',
      image: 'https://via.placeholder.com/150'
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('All Categories');
  const [statusFilter, setStatusFilter] = useState('All Status');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [editingBlog, setEditingBlog] = useState(null);
  const [titleError, setTitleError] = useState("");
  const [shortDescError, setShortDescError] = useState("");
  const [fullStoryError, setFullStoryError] = useState("");
  const [imageError, setImageError] = useState("");

  const [formData, setFormData] = useState({
    title: '',
    shortDesc: '',
    fullStory: '',
    category: 'Student',
    image: '',
    status: 'Draft'
  });

  // Filter blogs
  const filteredBlogs = blogs.filter(blog => {
    const matchesSearch = blog.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = categoryFilter === 'All Categories' || blog.category === categoryFilter;
    const matchesStatus = statusFilter === 'All Status' || blog.status === statusFilter;
    return matchesSearch && matchesCategory && matchesStatus;
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredBlogs.length / itemsPerPage);

  const handleAddNew = () => {
    setEditingBlog(null);
    setFormData({
      title: '',
      shortDesc: '',
      fullStory: '',
      category: 'Student',
      image: '',
      status: 'Draft'
    });
    setView('form');
  };

  const handleEdit = (blog) => {
    setEditingBlog(blog);
    setFormData({
      title: blog.title,
      shortDesc: blog.shortDesc,
      fullStory: blog.fullStory,
      category: blog.category,
      image: blog.image,
      status: blog.status === 'Active' ? 'Publish' : 'Draft'
    });
    setView('form');
  };

  const handleView = (blog) => {
    setSelectedBlog(blog);
    setShowViewModal(true);
  };

  const handleDelete = (blog) => {
    setSelectedBlog(blog);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    setBlogs(blogs.filter(b => b.id !== selectedBlog.id));
    setShowDeleteModal(false);
    setSelectedBlog(null);
  };

  const handleActive = () => {
    setBlogs(blogs.map(b => b.id === selectedBlog.id ? { ...b, status: 'Active' } : b));
    setShowViewModal(false);
  };

  const handleInActive = () => {
    setBlogs(blogs.map(b => b.id === selectedBlog.id ? { ...b, status: 'InActive' } : b));
    setShowViewModal(false);
  };

  const handleSubmit = () => {
    if (editingBlog) {
      setBlogs(blogs.map(b => b.id === editingBlog.id ? {
        ...b,
        ...formData,
        status: formData.status === 'Publish' ? 'Active' : 'InActive',
        date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      } : b));
    } else {
      const newBlog = {
        id: blogs.length + 1,
        ...formData,
        status: formData.status === 'Publish' ? 'Active' : 'InActive',
        date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      };
      setBlogs([...blogs, newBlog]);
    }
    setView('list');
  };

  const getStatusClass = (status) => {
    if (status === 'Active') return 'bm-status-Active';
    // if (status === 'InActive') return 'bm-status-InActive';
    return 'bm-status-InActive';
  };

  return (
    <Adminlayout>
      <div className="bm-container">
        {view === 'list' ? (
          <>
            {/* Header */}
            <div className="bm-header">
              <TitleBar
                title="Blogs/Stories"
                subtitle="Manage, review and publish website stories"
              ></TitleBar>
            </div>

            <div className="d-flex justify-content-end mb-3">
              <button className="bm-add-btn" onClick={handleAddNew}>
                <Plus size={20} />
                <span>Add New Story</span>
              </button>
            </div>

            {/* Main Content */}
            <div className="bm-content">
              {/* Search and Filters */}
              <Card className="bm-filter-card mb-4">
                <Card.Body>
                  <Row className="align-items-center">
                    <Col lg={6} md={12} className="mb-3 mb-lg-0">
                      <InputGroup>
                        <InputGroup.Text className="bm-search-icon">
                          <FaSearch />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder="Search Stories..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="bm-search-input"
                        />
                      </InputGroup>
                    </Col>

                    <Col lg={3} md={6} className="mb-3 mb-lg-0">
                      <InputGroup>
                        <InputGroup.Text className="bm-filter-icon">
                          <FaFilter />
                        </InputGroup.Text>
                        <Form.Select
                          value={categoryFilter}
                          onChange={(e) => setCategoryFilter(e.target.value)}
                          className="bm-filter-select"
                        >
                          <option value="All Categories">All Categories</option>
                          <option value="Student">Student</option>
                          <option value="Donor">Donor</option>
                          <option value="NGO">NGO</option>
                        </Form.Select>
                      </InputGroup>
                    </Col>

                    <Col lg={3} md={6}>
                      <InputGroup>
                        <InputGroup.Text className="bm-filter-icon">
                          <FaFilter />
                        </InputGroup.Text>
                        <Form.Select
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                          className="bm-filter-select"
                        >
                          <option value="All Status">All Status</option>
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                          {/* <option value="Approved">Approved</option> */}
                        </Form.Select>
                      </InputGroup>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Table */}
              <Card className="bm-table-card">
                <Card.Body>
                  <div className="bm-table-container">
                    <table className="bm-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Image</th>
                          <th>Title</th>
                          <th>Category</th>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentBlogs.map((blog, index) => (
                          <tr key={blog.id}>
                            <td>{indexOfFirstItem + index + 1}</td>
                            <td>
                              <img src={blog.image} alt={blog.title} className="bm-table-image" />
                            </td>
                            <td className="bm-table-title">{blog.title}</td>
                            <td>{blog.category}</td>
                            <td>
                              <span className={`bm-status-badge ${getStatusClass(blog.status)}`}>
                                {blog.status}
                              </span>
                            </td>
                            <td>{blog.date}</td>
                            <td>
                              <div className="bm-actions">
                                <button className="bm-action-btn bm-view" onClick={() => handleView(blog)} title="View">
                                  <Eye size={16} />
                                </button>
                                <button className="bm-action-btn bm-edit" onClick={() => handleEdit(blog)} title="Edit">
                                  <Edit2 size={16} />
                                </button>
                                <button className="bm-action-btn bm-delete" onClick={() => handleDelete(blog)} title="Delete">
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="bm-pagination">
                      <div className="bm-pagination-info">
                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredBlogs.length)} of {filteredBlogs.length} entries
                      </div>
                      <div className="bm-pagination-controls">
                        <button
                          className="bm-page-btn"
                          onClick={() => setCurrentPage(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          <ChevronLeft size={18} />
                          Prev
                        </button>

                        {[...Array(totalPages)].map((_, index) => (
                          <button
                            key={index + 1}
                            className={`bm-page-btn ${currentPage === index + 1 ? 'active' : ''}`}
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </button>
                        ))}

                        <button
                          className="bm-page-btn"
                          onClick={() => setCurrentPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                          <ChevronRight size={18} />
                        </button>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </>
        ) : (
          /* Form View */
          <div className="bm-form-container">
            <button className="bm-back-btn" onClick={() => setView('list')}>
              <ArrowLeft size={20} />
              Back to Stories
            </button>

            <h2 className="bm-form-title">{editingBlog ? 'Edit Story' : 'Add Story'}</h2>

            <div className="bm-form">
              <div className="bm-form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => {
                    const value = e.target.value;

                    setFormData({ ...formData, title: value });
                    setTitleError(regExpChecker("string", value));
                  }}
                  placeholder="Enter story title"
                />
                <p style={{ color: "red", fontSize: "12px" }}>{titleError}</p>
              </div>

              <div className="bm-form-group">
                <label>Short Description</label>
                <input
                  type="text"
                  value={formData.shortDesc}
                  onChange={(e) => {
                    const value = e.target.value;

                    setFormData({ ...formData, shortDesc: value });

                    setShortDescError(regExpChecker("string", value));
                     
                  }}
                  placeholder="Enter short description"
                />
                <p style={{ color: "red", fontSize: "12px" }}>{shortDescError}</p>
              </div>

              <div className="bm-form-group">
                <label>Full Story</label>
                <textarea
                  value={formData.fullStory}
                  onChange={(e) => {
                    const value = e.target.value;

                    setFormData({ ...formData, fullStory: value });

                    setFullStoryError(
                      value.length < 30 ? "Story must be at least 30 characters" : ""
                    );
                  }}
                  placeholder="Enter full story content"
                  rows="6"
                />
                <p style={{ color: "red", fontSize: "12px" }}>{fullStoryError}</p>
              </div>

              <div className="bm-form-group">
                <label>Category</label>
                <select
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                >
                  <option>Student</option>
                  <option>Donor</option>
                  <option>NGO</option>
                </select>
              </div>

              <div className="bm-form-group">
                <label>Cover Image</label>
                <div className="bm-upload-box">
                  <Upload size={24} />
                  <span>Upload Image</span>
                  <input
                    type="text"
                    value={formData.image}
                    onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                    placeholder="Enter image URL"
                  />
                </div>
              </div>

              <div className="bm-form-group">
                <label>Status</label>
                <div className="bm-radio-group">
                  <label className="bm-radio-label">
                    <input
                      type="radio"
                      checked={formData.status === 'Draft'}
                      onChange={() => setFormData({ ...formData, status: 'Draft' })}
                    />
                    <span>Draft</span>
                  </label>
                  <label className="bm-radio-label">
                    <input
                      type="radio"
                      checked={formData.status === 'Publish'}
                      onChange={() => setFormData({ ...formData, status: 'Publish' })}
                    />
                    <span>Publish</span>
                  </label>
                </div>
              </div>

              <div className="bm-form-actions">
                <button className="bm-btn-cancel" onClick={() => setView('list')}>
                  Cancel
                </button>
                <button className="bm-btn-save" onClick={handleSubmit}>
                  Save Story
                </button>
              </div>
            </div>
          </div>
        )}

        {/* View Modal */}
        {showViewModal && selectedBlog && (
          <div className="bm-modal-overlay" onClick={() => setShowViewModal(false)}>
            <div className="bm-modal" onClick={(e) => e.stopPropagation()}>
              <div className="bm-modal-header">
                <h2>View Story</h2>
                <button className="bm-modal-close" onClick={() => setShowViewModal(false)}>
                  <X size={24} />
                </button>
              </div>

              <div className="bm-modal-content">
                <img src={selectedBlog.image} alt={selectedBlog.title} className="bm-modal-image" />

                <div className="bm-modal-info">
                  <h3>{selectedBlog.title}</h3>
                  <p><strong>Category:</strong> {selectedBlog.category}</p>
                  <p><strong>Date:</strong> {selectedBlog.date}</p>
                </div>

                <div className="bm-modal-story">
                  <h4>Full Story</h4>
                  <p>{selectedBlog.fullStory}</p>
                </div>
              </div>

              <div className="bm-modal-footer">
                <button className="bm-btn-InActive" onClick={handleInActive}>
                  InActive
                </button>
                <button className="bm-btn-Active" onClick={handleActive}>
                  Active
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Modal */}
        {showDeleteModal && (
          <div className="bm-modal-overlay" onClick={() => setShowDeleteModal(false)}>
            <div className="bm-modal bm-delete-modal" onClick={(e) => e.stopPropagation()}>
              <div className="bm-modal-header">
                <h2>Delete Story</h2>
              </div>

              <div className="bm-modal-content">
                <p>Are you sure you want to delete this story?</p>
              </div>

              <div className="bm-modal-footer">
                <button className="bm-btn-cancel" onClick={() => setShowDeleteModal(false)}>
                  Cancel
                </button>
                <button className="bm-btn-delete" onClick={confirmDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Adminlayout>
  );
};

export default BlogManagement;